function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Events.css';
import React from 'react';
import { get, getDictionaryItem, getTags, generatrURLFromTags, getFeaturedItemAndList, getTagsNames, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { ReactComponent as ChevronDown } from '../../resources/icons/IconChevronDownBlue.svg';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../atoms/RouterLink';
import getListing, { loadCategoryAlgoliaResults, formatTagsRuleToFilters, generateSeeMoreTagsFromRules, formatTagsRuleToFiltersOneByOne, isTagsRule } from '../../utils/getListing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
// import Video from '../atoms/Video';
import ScrollAnimation from 'react-animate-on-scroll';
import EventBlock from './components/EventBlock';
import FeaturedEventBlock from './components/FeaturedEventBlock';
// import loadable from '@loadable/component';

//personlization

import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
// const Scrollbars = loadable(() => import('react-custom-scrollbars'), { ssr: false });
import { useInView } from 'react-intersection-observer';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil } from '../../utils/IsNil';
import useProfile from '../../utils/hooks/useProfile';
const baseImage = process.env.REACT_APP_MEDIA_HOST || '';
const getFormatedDate = (date, lang) => {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    day: 'numeric',
    month: 'short'
  });
};
export const convertDate = function (startDate, endDate) {
  let lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-GB';
  const date = [];
  if (startDate) {
    date.push(getFormatedDate(startDate, lang));
  }
  if (endDate) {
    date.push(getFormatedDate(endDate, lang));
  }
  return date.join(' - ');
};
export const Events = _ref => {
  let {
    params,
    fields,
    route
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  let currentLang = get(sitecoreContext, 'language');
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const userProfile = useProfile();
  const [ref, inView] = useInView({
    threshold: 1,
    triggerOnce: true
  });
  if (currentLang === 'no') {
    currentLang = 'nob';
  }
  const currentPageID = get(route, 'itemId', '').split('-').join('');

  // exempt the item of page of event in which Events applied
  const pageFilter = currentPageID ? `NOT objectID:${currentPageID}` : '';
  const contextItemId = get(fields, 'data.contextItem.id');
  let curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = `?curators.curators.Id=${contextItemId}`;
  }
  const renderingId = get(fields, 'data.datasource.id') || '';
  const useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  const considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  const listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.value.href');
  const discoverMoreLink = useCustomListingPage ? listingPageLink : get(fields, 'data.overviewButton.link.jss.value.href');
  const tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  const isTagsRuleUsed = isTagsRule(tagsRule);
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const countryItems = get(fields, 'data.countries.countryValues') || [];
  const moduleDictionary = get(fields, 'data.moduleDictionary');
  const dictionary = get(fields, 'data.dictionary');
  const defaultTitle = getDictionaryItem(moduleDictionary, 'EventsTitle');
  const multipleDates = getDictionaryItem(moduleDictionary, 'multipleDates') || 'Multiple days, next on';
  const hasItems = Boolean(get(fields, 'data.dictionary.dictionaryValues.length'));
  const showFeatured = get(fields, 'data.datasource.showFeatured.jss.value');
  const searchCount = showFeatured ? 5 : Number(get(params, 'SearchCount'));
  const ThemeBased = params !== undefined && params['Background Color'] === 'Theme Based' ? true : false;
  const GreyTheme = params !== undefined && params['Background Color'] === 'Grey' ? true : false;
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const ColorHex = get(params, 'ColorHex');
  const primaryColor = BackgroundColorHex ? BackgroundColorHex : selectedPrimaryColor;
  const color = BackgroundColorHex ? ColorHex : getColorByTheme(selectedPrimaryColor);
  const activeColor = BackgroundColorHex ? ActiveColorHex : selectedPrimaryActiveColor;
  const styleThemeHexColor = ThemeBased ? {
    '--events-theme-background-color': primaryColor,
    '--events-theme-text-color': color,
    '--events-theme-container-background-color': BackgroundColorHex ? BackgroundColorHex : primaryColor,
    '--events-theme-text-selection-color': BackgroundColorHex ? BackgroundColorHex : primaryColor,
    '--events-theme-hex-color': color,
    '--events-theme-btn-hex-color': color,
    '--events-theme-dots-hex-color': color,
    '--events-theme-arrow-hex-color': activeColor,
    '--events-theme-background-active-color': activeColor
  } : {
    '--events-theme-background-color': primaryColor,
    '--events-theme-text-color': color,
    '--events-theme-container-background-color': GreyTheme ? '#EEEEEF' : '#fff',
    '--events-theme-text-selection-color': primaryColor,
    '--events-theme-hex-color': '#000',
    '--events-theme-btn-hex-color': primaryColor,
    '--events-theme-dots-hex-color': '#505050',
    '--events-theme-arrow-hex-color': primaryColor,
    '--events-theme-background-active-color': activeColor
  };
  const isInteractive = get(fields, 'data.datasource.interactive.jss.value');
  const isFilterByCurrentMonth = get(fields, 'data.datasource.filterByCurrentMonth.jss.value');
  const intents = get(fields, 'data.datasource.intents');
  const intentsLength = get(intents, 'targetItems.length');
  const overviewButton = get(fields, 'data.overviewButton');
  const overviewButtonTitle = get(fields, 'data.overviewButton.title.jss');
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues');
  const items = hasItems ? dictionaryValues : [];
  const map = items.reduce((aggregator, currentValue) => aggregator.set(currentValue.key.jss.value, currentValue.phrase.jss), new Map());
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const indexName = get(params, 'SearchIndex');
  const contextTags = getTags(get(fields, 'data.contextItem.tags'));
  const itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  const upcomingEventsIn = map.get('UpcomingEventsIn');
  const curatorsPick = map.get('CuratorsPick');
  const whereToFindUsIn = map.get('WhereToFindUsIn');
  const titleEventCheckInteractive = get(fields, 'data.datasource.title.jss.value');
  const titleEventCheck = get(fields, 'data.datasource.title.jss.value');
  const titleEvent = get(fields, 'data.datasource.title.jss') || {
    value: defaultTitle
  };
  const theme = get(sitecoreContext, 'themesOfPage');
  const {
    isPersonalised
  } = sitecoreContext;
  const divRef = /*#__PURE__*/React.createRef();
  const scrollRef = /*#__PURE__*/React.createRef();
  const curatorsPickCopy = get(curatorsPick, 'value');
  const currentMonth = new Date().getMonth();
  const months = new Array(12).fill(null).map((val, idx) => {
    let index = idx + 1 + currentMonth;
    index = index > 12 ? index - 12 : index;
    const label = new Date(`1999/${index}/5`).toLocaleDateString(currentLang, {
      month: 'long',
      timeZone: 'UTC'
    });
    return {
      label,
      index
    };
  });
  const [events, setSearchResults] = React.useState([]);
  const [isHidden, setIsHidden] = React.useState(false);
  const [selectedMonth, setSelectedMonth] = React.useState(months[0].label);
  const contextItem = get(fields, 'data.contextItem');
  const d = new Date();
  const getCurrentMonth = d.getMonth() + 1;

  // Resolve used conditions based on what is selected with the integrated query
  const conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  const allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(condition => {
    const {
      handler,
      mappings
    } = condition;
    const conditionValues = handler.getValues({
      mappings,
      sitecoreContext
    });
    if (conditionValues) {
      allValues.push(...conditionValues);
    }
  });
  const {
    personalizedList,
    refreshTracking
  } = usePersonalizedList({
    rendering: contextItem,
    route,
    list: events,
    conditions: [algoliaScoredCondition(allValues)]
  });
  const [firstEvents, setFirstEvents] = React.useState(null);
  const [firstImage, setFirstImage] = React.useState('');
  const [seeMoreURLTags, setSeeMoreURLTags] = React.useState('');
  const contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  const datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  const tagsList = isTagsRuleUsed ? formatTagsRuleToFilters(tagsRule) : considerPageLevelTags ? [...contextItemTags, ...datasourceTags] : datasourceTags;
  const tagsListForSeeMore = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextItemTags;
  const tagNameList = getTagsNames(tagsList, 'tags:');
  /* const tagNameList = ['tags:Sports']; */

  const tagListKey = itemTags;
  React.useEffect(() => {
    setSeeMoreURLTags(generatrURLFromTags(tagsListForSeeMore));
    let facetFilters = [];
    if (inView) {
      if (contextItemId) {
        facetFilters = [`curators.curators.Id:${contextItemId}`];
      }
      if (!intentsLength) {
        const d = new Date();
        const getMonth = d.getMonth() + 1;
        let filters = `${pageFilter} ${isFilterByCurrentMonth || isInteractive ? `AND ( datesRange.to >= ${Date.parse(`${d.getFullYear()}/${getMonth}/1`) / 1000})` : ''}`;
        let facetFilters = [['type:Event'], isInteractive ? [`eventMonths:${getMonth}`] : isFilterByCurrentMonth ? [`eventMonths:${getMonth}`] : [], [contextItemId ? `curators.curators.Id:${contextItemId}` : '']];
        let itemFilter = {
          //face
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [...facetFilters, ...[tagNameList]],
          filters
        };
        getListing(indexName, itemFilter, algoliaSettings).then(hits => {
          hits && hits.hits.length ? setIsHidden(false) : setIsHidden(true);
          if (hits && hits.hits.length) {
            if (showFeatured && !isInteractive) {
              const {
                list,
                featured
              } = getFeaturedItemAndList(hits.hits);
              setFirstEvents(featured);
              setSearchResults(list);
              setFirstImage(get(featured, 'image'));
            } else {
              setSearchResults(hits.hits);
            }
          } else {
            // show next year events if current month has already passed in the current year
            const isNextYear = getMonth < getCurrentMonth;
            const nextMonth = isNextYear ? 1 : getMonth + 1;
            let filters = `${pageFilter} AND (datesRange.to >= ${isNextYear ? Date.parse(`${d.getFullYear() + 1}/${nextMonth}/1`) / 1000 : Date.parse(`${d.getFullYear()}/${nextMonth}/1`) / 1000} )`;
            let facetFilters = [['type:Event'], [`eventMonths:${nextMonth}`], [contextItemId ? `curators.curators.Id:${contextItemId}` : '']];
            itemFilter = {
              //face
              hitsPerPage: searchCount,
              facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [...facetFilters, ...[tagNameList]],
              filters
            };
            setSelectedMonth(months[1].label);
            getListing(indexName, itemFilter, algoliaSettings).then(hits => {
              if (showFeatured && !isInteractive) {
                const {
                  list,
                  featured
                } = getFeaturedItemAndList(hits.hits);
                setFirstEvents(featured);
                setSearchResults(list);
                setFirstImage(get(featured, 'image'));
              } else {
                setSearchResults(hits.hits);
              }
            });
          }
        });
      } else {
        (async () => {
          const hits = await loadCategoryAlgoliaResults(allValues || [], algoliaSettings, ['type:Event'], searchCount, isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, [['type:Event']]) : tagListKey && tagListKey, [contextItemId ? `curators.curators.Id:${contextItemId}` : ''], currentPageID ? `NOT objectID:${currentPageID}` : '', indexName, true);
          hits && hits.length ? setIsHidden(false) : setIsHidden(true);
          if (showFeatured && !isInteractive) {
            const {
              list,
              featured
            } = getFeaturedItemAndList(hits);
            setFirstEvents(featured);
            setSearchResults(list);
            setFirstImage(get(featured, 'image'));
          } else {
            setSearchResults(hits);
          }
          refreshTracking();
        })();
      }
    }
  }, [isPersonalised, inView]);

  //get first feature

  function isFirstFeature(items) {
    if (!showFeatured) {
      return false;
    }
    return items.featured === true;
  }
  let firstTime = true;
  const toogleDateActive = e => {
    e.preventDefault();
    divRef.current && divRef.current.classList.toggle('active');
    tealiumClickFunc(params, 'Month Dropdown Click');
    if (firstTime) {
      firstTime = false;
      let current = get(scrollRef, 'current.scrollTop');
      current(1);
    }
  };
  const toogleDateKeyPress = e => {
    e.preventDefault();
    if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.which === 32) {
      toogleDateActive(e);
    }
  };
  const handleMonthClick = (e, month, currentMonth, index) => {
    e.preventDefault();
    setSelectedMonth(month);
    const currentMonthIndex = e.target.getAttribute('data-index');
    const d = new Date();

    // show next year events if current month has already passed in the current year
    const isNextYear = currentMonthIndex < getCurrentMonth;

    /* let filters = `${pageFilter} ${currentPageID ? 'AND' : ''} (datesRange.to >= ${ //01-10-2025
      isNextYear
        ? Date.parse(`${d.getFullYear() + 1}/${currentMonthIndex}/1`) / 1000
        : Date.parse(`${d.getFullYear()}/${currentMonthIndex}/1`) / 1000
    } ) AND ( datesRange.to <= ${
      isNextYear
        ? new Date(`${d.getFullYear() + 1}-12-31T23:59:59Z`).getTime() / 1000
        : new Date(`${d.getFullYear()}-12-31T23:59:59Z`).getTime() / 1000
    })`; */

    let filters = `${pageFilter} ${currentPageID ? 'AND' : ''} (datesRange.to >= ${
    //01-10-2025
    isNextYear ? Date.parse(`${d.getFullYear() + 1}/${currentMonthIndex}/1`) / 1000 : Date.parse(`${d.getFullYear()}/${currentMonthIndex}/1`) / 1000} )`;
    let facetFilters = [['type:Event'], [`eventMonths:${currentMonthIndex}`], [contextItemId ? `curators.curators.Id:${contextItemId}` : '']];
    let itemFilter = {
      hitsPerPage: searchCount,
      facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [...facetFilters, ...[tagNameList]],
      filters
    };
    getListing(indexName, itemFilter, algoliaSettings).then(_ref2 => {
      let {
        hits
      } = _ref2;
      hits && hits.length ? setIsHidden(false) : setIsHidden(true);
      if (showFeatured && !isInteractive) {
        const {
          list,
          featured
        } = getFeaturedItemAndList(hits);
        setFirstEvents(featured);
        setSearchResults(list);
        setFirstImage(get(featured, 'image'));
      } else {
        setSearchResults(hits);
      }
    });
    divRef.current && divRef.current.classList.remove('active');
  };
  const handleSelectChange = e => {
    // e.preventDefault();
    let month = e.currentTarget.selectedOptions[0].innerText || '';
    setSelectedMonth(month);
    const currentMonthIndex = Number(e.currentTarget.selectedOptions[0].getAttribute('data-index'));
    const d = new Date();
    // show next year events if current month has already passed in the current year
    const isNextYear = currentMonthIndex < getCurrentMonth;
    /* let filters = `${pageFilter} ${currentPageID ? 'AND' : ''} (datesRange.to >= ${
      isNextYear
        ? Date.parse(`${d.getFullYear() + 1}/${currentMonthIndex}/1`) / 1000
        : Date.parse(`${d.getFullYear()}/${currentMonthIndex}/1`) / 1000
    } ) AND ( datesRange.to <= ${
      isNextYear
        ? new Date(`${d.getFullYear() + 1}-12-31T23:59:59Z`).getTime() / 1000
        : new Date(`${d.getFullYear()}-12-31T23:59:59Z`).getTime() / 1000
    })`; */
    let filters = `${pageFilter} ${currentPageID ? 'AND' : ''} (datesRange.to >= ${isNextYear ? Date.parse(`${d.getFullYear() + 1}/${currentMonthIndex}/1`) / 1000 : Date.parse(`${d.getFullYear()}/${currentMonthIndex}/1`) / 1000} )`;
    let facetFilters = [['type:Event'], [`eventMonths:${currentMonthIndex}`], [contextItemId ? `curators.curators.Id:${contextItemId}` : '']];
    let itemFilter = {
      hitsPerPage: searchCount,
      facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [...facetFilters, ...[tagNameList]],
      filters
    };
    getListing(indexName, itemFilter, algoliaSettings).then(_ref3 => {
      let {
        hits
      } = _ref3;
      hits && hits.length ? setIsHidden(false) : setIsHidden(true);
      if (showFeatured && !isInteractive) {
        const {
          list,
          featured
        } = getFeaturedItemAndList(hits);
        setFirstEvents(featured);
        setSearchResults(list);
        setFirstImage(get(featured, 'image'));
      } else {
        setSearchResults(hits);
      }
    });
  };
  const renderMonths = () => months.map((month, index) => /*#__PURE__*/React.createElement("li", {
    tabIndex: 0,
    key: index,
    "data-index": month.index,
    className: `select-item to-capitalize ${selectedMonth === month.label ? 'select-item--selected' : ''}`,
    onClick: e => {
      handleMonthClick(e, month.label, currentMonth, index);
      tealiumClickFunc(params, `Month Selection : ${month.label}`);
    },
    onKeyPress: e => {
      e.preventDefault();
      if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.which === 32) {
        handleMonthClick(e, month.label, currentMonth, index);
        tealiumClickFunc(params, `Month Selection : ${month.label}`);
      }
    }
  }, month.label));
  const renderSelectMonths = () => months.map((month, index) => /*#__PURE__*/React.createElement("option", {
    "data-index": month.index,
    className: "to-capitalize",
    value: month.label,
    key: index
  }, month.label));
  const renderItems = () => {
    let itemsToMap = searchCount;
    if (isNil(overviewButton)) {
      return [];
    }
    return validateItems.slice(0, itemsToMap).map((event, index) => {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        key: event.objectID,
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3
      }, /*#__PURE__*/React.createElement(EventBlock, {
        userProfile: userProfile,
        event: event && event.item ? event.item : event,
        curatorsCopy: curatorsPickCopy,
        lang: currentLang,
        multipleDates: multipleDates,
        hostLink: overviewButton.link.jss.value.href + curtorListingPage,
        analytics: {
          eventsAnalytics,
          params
        },
        countryItems: countryItems,
        themeValues: Object.values(styleThemeHexColor),
        inSlider: true
      }));
    });
  };
  const renderTitle = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: "events__title-block"
    }, titleEventCheck ? /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "events__title",
      field: titleEvent
    }) : /*#__PURE__*/React.createElement("h2", {
      className: "events__title"
    }, defaultTitle));
  };
  const renderInteractiveTitle = function (selectId) {
    let titleClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "events__title-block";
    return /*#__PURE__*/React.createElement("div", {
      className: titleClassName
    }, /*#__PURE__*/React.createElement("div", {
      className: "h2 events__title events__interactive-title c__title"
    }, titleEventCheckInteractive ? /*#__PURE__*/React.createElement(Text, {
      className: "span",
      tag: "span",
      field: {
        value: titleEventCheckInteractive
      }
    }) : /*#__PURE__*/React.createElement(Text, {
      className: "span",
      tag: "span",
      field: _objectSpread({}, upcomingEventsIn)
    }), /*#__PURE__*/React.createElement("div", {
      className: "events__dd-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn btn-tertiary btn-select cc__custom-dd",
      tabIndex: 0,
      onClick: toogleDateActive,
      onKeyPress: toogleDateKeyPress
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-tertiary__text to-capitalize"
    }, selectedMonth), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(ChevronDown, {
      className: "btn-tertiary__icon btn-link__icon btn-link-icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "section__select-mob"
    }, /*#__PURE__*/React.createElement("label", {
      className: "accessibility-hidden-text",
      htmlFor: `${selectId}-${renderingId}`
    }, titleEventCheckInteractive ? titleEventCheckInteractive : upcomingEventsIn.value), /*#__PURE__*/React.createElement("select", {
      className: "select_form",
      id: selectId,
      onChange: handleSelectChange
    }, renderSelectMonths()))), /*#__PURE__*/React.createElement("div", {
      className: "section__select",
      "data-index": "1",
      ref: divRef
    }, /*#__PURE__*/React.createElement("ul", {
      className: "select-location months"
    }, /*#__PURE__*/React.createElement(Scrollbars, {
      ref: scrollRef,
      style: {
        width: '100%',
        height: 200
      },
      renderTrackHorizontal: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "track-horizontal"
      })),
      renderTrackVertical: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "track-vertical"
      })),
      renderThumbHorizontal: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "thumb-horizontal"
      })),
      renderThumbVertical: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "thumb-vertical"
      })),
      renderView: props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "view"
      }))
    }, renderMonths()))))));
  };
  const showFeatureCondition = !isInteractive && firstEvents && showFeatured;
  const renderFeatureItem = () => showFeatureCondition ? /*#__PURE__*/React.createElement("div", {
    className: "container m15-events"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: `events__featured-block events__featured-block--highlighted ${theme ? 'brand-bg' : ''}`
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, renderTitle()), overviewButton && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 100
  }, /*#__PURE__*/React.createElement(FeaturedEventBlock, {
    userProfile: userProfile,
    event: firstEvents,
    curatorsCopy: curatorsPickCopy,
    lang: currentLang,
    multipleDates: multipleDates,
    hostLink: overviewButton.link.jss.value.href + curtorListingPage,
    analytics: {
      eventsAnalytics,
      params
    },
    countryItems: countryItems,
    themeValues: Object.values(styleThemeHexColor)
  }))))) : null;
  const validateItems = intentsLength && isPersonalised ? personalizedList : events;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isHidden: true,
    anchorUrlParameter: params['Anchor Url Parameter'],
    styleThemeHexColor: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, renderFeatureItem(), /*#__PURE__*/React.createElement("div", {
    className: "container m15-events "
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: 'col-md-12 col-xl-12'
  }, validateItems && validateItems.length > 0 && validateItems.length >= 5 && /*#__PURE__*/React.createElement(CarouselProvider, null, _ref4 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots,
      state
    } = _ref4;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xl-12 events-pagination__btn-wrapper"
    }, !showFeatureCondition && /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, isInteractive ? renderInteractiveTitle('tilesFull') : renderTitle()), /*#__PURE__*/React.createElement("div", {
      className: `events-pagination__btn ${rtl ? 'btn-group-rtl' : ''}`
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNextNavAnalytics'], params))), renderNextButton(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNextNavAnalytics'], params)))))), renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: 4
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1280
          },
          items: 3
        },
        tablet_landscape: {
          breakpoint: {
            max: 1280,
            min: 768
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "events-pagination__dots"
    }, /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: "events-dots-wrapper__fadeInUp",
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1,
      delay: 200
    }, /*#__PURE__*/React.createElement("div", {
      className: "article__link"
    }, overviewButton.title.jss.value && /*#__PURE__*/React.createElement(RouterLink, {
      openInSameTab: true,
      className: "btn btn-secondary btn-mob",
      href: discoverMoreLink + curtorListingPage + seeMoreURLTags,
      onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params))
    }, overviewButton.title.jss.value))), renderDots(() => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params)))));
  }), validateItems && validateItems.length > 0 && validateItems.length < 5 && /*#__PURE__*/React.createElement(React.Fragment, null, !showFeatureCondition && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, isInteractive ? renderInteractiveTitle('tilesPartial') : renderTitle()), /*#__PURE__*/React.createElement("div", {
    className: `events__items`
  }, renderItems()), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "events-dots-wrapper__fadeInUp",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__link margin-top"
  }, overviewButton.title.jss.value && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-secondary btn-mob",
    href: discoverMoreLink + curtorListingPage + seeMoreURLTags,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params))
  }, overviewButton.title.jss.value)))), isInteractive && isHidden && /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, renderInteractiveTitle('tilesEmpty', 'events__title-block__no-events')), /*#__PURE__*/React.createElement("div", {
    className: "no-events"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "no-events__message"
  }, getDictionaryItem(moduleDictionary, 'no events in this month'))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    className: "events-dots-wrapper__fadeInUp",
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: "article__link"
  }, overviewButton.title.jss.value && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-secondary btn-mob",
    href: discoverMoreLink + curtorListingPage + seeMoreURLTags,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params))
  }, overviewButton.title.jss.value))))), /*#__PURE__*/React.createElement(React.Fragment, null)))));
};
const StyledWrapper = _ref5 => {
  let {
    children,
    rtl,
    isHidden,
    anchorUrlParameter,
    styleThemeHexColor
  } = _ref5;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true
    /* className={`${commonStyles} ${rtl ? rtlStyles : ltrStyles}  ${commonoFocusEvent} ${ColorsLogic}`} */,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${ColorsLogic}`,
    style: styleThemeHexColor
  }, children) : null, ' ');
};
const ColorsLogic = "c1as7mzs";
/* const commonoFocusEvent = css`
  .events__interactive-title .cc__custom-dd:focus {
    outline: none;
  }
`; */

export const commonStyles = "c1ue9rtw";
const ltrStyles = "l1ruemiz";
const rtlStyles = "r1fklu25";
export default Events;